import type {GetStaticProps} from 'next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {LandingSections} from '@tempo/landing';
import {
	HeroBlock,
	MoodRail,
	Fraud,
	Sacem,
	Monetization,
	Artist,
	Work,
	FAQ,
} from '@app/views/artist-remuneration';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {useTranslation} from '@app/hooks/use-translation';
import {getArtistremunerationGQLData} from '@app/modules/ssg-data/artist-remuneration/server';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';

const ArtistRemunerationPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation({ns: ['remuneration']});

	const pageTitle = t('acpslandingpage_title_seotitle_standalone-web');
	const pageDescription = t(
		'acpslandingpage_text_seodescription_standalone-web',
	);
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections>
				<HeroBlock />
				<Artist />
				<Work />
				<Monetization />
				<Fraud />
				<Sacem />
				<MoodRail />
				<FAQ />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'remuneration',
		'common',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
				...(await getArtistremunerationGQLData({
					locale,
					ids: [
						'1479458365',
						'3338949242',
						'2268939442',
						'1904124402',
						'8788949122',
					],
				})),
			},
			tracking: {
				pagecategory: 'artistremuneration',
				pagename: 'artistremuneration',
			},
		},
		revalidate: 15 * 60,
	};
};

export default ArtistRemunerationPage;
